
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/random",
      function () {
        return require("private-next-pages/random/index.tsx");
      }
    ]);
  